import React from 'react'

export const Water = () => {
  return (
    <div className='watericon'>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="19" viewBox="0 0 14 19" fill="none">
        <path d="M6.71642 18.75C4.93511 18.75 3.22677 18.0424 1.96719 16.7828C0.707621 15.5232 0 13.8149 0 12.0336C0 7.55597 6.71642 0 6.71642 0C6.71642 0 13.4328 7.55597 13.4328 12.0336C13.4328 13.8149 12.7252 15.5232 11.4656 16.7828C10.2061 18.0424 8.49772 18.75 6.71642 18.75Z" fill="white"/>
        </svg>
    </div>
  )
}
